import { IBSBBranchDetails } from './../../interfaces/entities/bsb-branch-details.interface';
import type { IPaymentConfigurationRequest } from '@/interfaces/entities/payment-configuration-request.interface';
import type { IPaymentConfigurationResponse } from '@/interfaces/entities/payment-configuration-response.interface';
import { RequestServices as _http } from '../common/request.services';
import {
  getApttusDirectDebitStatus,
  getFinancialInstitutionFromBsb,
  getPaymentConfiguration,
  postApplePayMerchantSession,
  postApplePayPayWithApple,
} from '@/constants/forms-api.const';
import { ApttusDirectDebitStatusResponse } from '@/interfaces/entities/apttus-direct-debit-status-response.interface';

export const PaymentServices = {
  /**
   * Get FZ Iframe URL
   *
   * @param payload
   * @returns
   */
  async getPaymentIframeConfiguration(payload: IPaymentConfigurationRequest): Promise<IPaymentConfigurationResponse> {
    if (!payload.reference || !payload.amount) return { url: '', hostUrl: '' };
    return await _http.HttpGet(
      `${getPaymentConfiguration}?reference=${payload.reference}&amount=${payload.amount}&buttonText=${payload.buttonText}&tokenizeOnly=${payload.tokenizeOnly}&googlepay=${payload.googlePay}`
    );
  },

  /**
   * BSB Lookup
   *
   * @param bsb
   */
  async bsbLookup(bsb: string): Promise<IBSBBranchDetails | null> {
    return await _http.HttpGet(getFinancialInstitutionFromBsb.replace('{0}', bsb));
  },

  /**
   * Retrieves the status of direct debit for the specified ApttusId.
   * NotFound = 0
   * Current = 1
   * @param apttusId
   * @returns
   */
  async getApttusDirectDebitStatus(apttusId: string): Promise<ApttusDirectDebitStatusResponse> {
    return await _http.HttpGet(getApttusDirectDebitStatus.replace('{0}', apttusId));
  },

  /**
   * Apple Pay - Create merchant validation session
   * Passes through the raw Apple merchant session JSON object from backend
   */
  async createApplePayMerchantSession(payload: {
    url: string;
    domainName: string;
    displayName: string;
  }): Promise<any> {
    return await _http.HttpPost(postApplePayMerchantSession, payload);
  },

  /**
   * Apple Pay - Submit payment using Apple Pay token (optional helper)
   * Note: Most flows will set paymentStore.cardDetails and use existing submit paths,
   * but this helper is available for direct wallet purchase flows if required.
   */
  async payWithApple(request: any): Promise<any> {
    return await _http.HttpPost(postApplePayPayWithApple, request);
  },
} as const;
